import { Create } from 'react-admin';
import { FormFields } from './components';

export const UserCreate = () => (
	<Create>
		{FormFields}
	</Create>
);

export default UserCreate;